import { useGetUserProfileQuery } from '@store/api/user.api';

export function useProfile() {
  const { data: profile = null } = useGetUserProfileQuery();

  return profile;
}
